module.exports = __webpack_public_path__ + "static/img/arrow-right-1.26eb91e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/arrow-right-1.png
// module id = od5D
// module chunks = 4